import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const lienHoldersAdapter = getAdapter();

const lienHoldersSlice = createSlice({
  name: 'lienHolders',
  initialState: lienHoldersAdapter.getInitialState(),
  reducers: {
    setLienHolders: (state, { payload: { lienHolders } }) => {
      lienHoldersAdapter.setAll(state, lienHolders);
    }
  }
});

const selectors = lienHoldersAdapter.getSelectors(({ lienHolders }) => lienHolders);

export const getLienHolders = state => selectors.selectAll(state);

export const { setLienHolders } = lienHoldersSlice.actions;

export default lienHoldersSlice.reducer;
